export default __webpack_public_path__ + "static/media/30 inex_01.4ecf245a.png";